import { Link } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import styles from "./Unauthorized.module.css";

const Unauthorized = () => {
  return (
    <AdminLayout title="Access Restricted">
      <div className={styles.card}>
        <h2 className={styles.title}>
          You do not have access to this page.
        </h2>
        <p className={styles.text}>
          Your current role does not include permission for this section.
        </p>
        <Link
          to="/dashboard"
          className={styles.link}
        >
          Back to Dashboard
        </Link>
      </div>
    </AdminLayout>
  );
};

export default Unauthorized;
